import { Link } from 'react-router';
import { NAV_PATH } from '@/router/constants';

/**
 * 문의하기 배너 컴포넌트
 * @returns JSX.Element
 */
const QuestionBanner = () => {
	return (
		<section className="main-qna main-section">
			<div className="main-qna-inner">
				<div className="txt-holder">
					<strong>지금 Stella ERP와 함께 새로운 비즈니스를 시작하세요!</strong>
					<p>
						Stella는 단순한 소프트웨어를 넘어, 기업의 미래를 함께 설계하는 전략적 파트너입니다. <br />
						유연한 데이터 통합, AI 기반 자동화, 모듈형 확장성을 통해 운영 효율을 극대화하고 미래 경쟁력을 확보하십시오.
						<br />
						<span className="color-white">Stella를 도입하여 미래지향적인 비즈니스 환경을 만들어보세요!</span>
					</p>
					<Link to={NAV_PATH.INQUIRY.SERVICE} className="btn primary">
						문의하기
					</Link>
				</div>
			</div>
		</section>
	);
};

export default QuestionBanner;
